import styles from "./SettingLabel.module.scss";

export function SettingLabel(props: {title: string, small?: boolean}) {
    return <span className={props.small ? styles.LabelSmall : styles.Label}>{props.title}</span>
}